// extracted by mini-css-extract-plugin
module.exports = {"skeletonLoader":"SkeletonLoader_skeletonLoader__oBxUq","darkSlide":"SkeletonLoader_darkSlide__IG_Z8","lightSlide":"SkeletonLoader_lightSlide__pGba4"};